export const FETCH_INTERNAL_CAMPAIGNS = 'hall/internalCampaigns/FETCH'
export const FETCH_INTERNAL_CAMPAIGNS_SUCCESS =
  'hall/internalCampaigns/FETCH_SUCCESS'
export const FETCH_INTERNAL_CAMPAIGNS_ERROR =
  'hall/internalCampaigns/FETCH_ERROR'
export const MARK_INTERNAL_CAMPAIGN_SEEN = 'hall/internalCampaigns/MARK_SEEN'
